export const LOGIN_PAGE = '/auth';
export const HOME_PAGE = '/support/remote';
export const REMOTE_ACCESS = '/support/access';
export const JOIN = '/join';
export const REMOTE_SUPPORT_REPORT = '/reports/remote/support';
